<template>
  <div class="lv-text-card" :class="{ outline: outline, red: color === 'red' }">
    <div class="lv-text-card__title-wrap">
      <slot name="title">
        <LvIcon v-if="leadingIcon" :icon="leadingIcon" :color="color" size="24px" />
        <LvText
          h4
          bold
          :blue="color === 'blue'"
          :red="color === 'red'"
          class="lv-text-card__title"
          >{{ $t(cardHeader) }}</LvText
        >
      </slot>
    </div>
    <div v-if="cartChapterTitle" class="lv-text-card__content">
      <p>
        {{ cartChapterTitle }}
      </p>
    </div>
    <slot name="content">
      <div v-if="cardContent" class="lv-text-card__content">
        <p>
          {{ cardContent }}
        </p>
      </div>
    </slot>
    <div v-if="diffName.length" class="lv-text-card__content">
      <p>
        <span
          v-for="(diff_e, diff_k) in diffName"
          :key="diff_k"
          :class="{ delete: diff_e.removed, correct: diff_e.added }"
          >{{ diff_e.value }}</span
        >
      </p>
    </div>
    <div v-if="diffText.length" class="lv-text-card__content">
      <p>
        <span
          v-for="(diff_e, diff_k) in diffText"
          :key="diff_k"
          :class="{ delete: diff_e.removed, correct: diff_e.added }"
          >{{ diff_e.value }}</span
        >
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    outline: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
      default: '',
    },
    trailingIcon: {
      type: String,
      default: '',
    },
    cardHeader: {
      type: String,
      default: '',
    },
    cardContent: {
      type: String,
      default: '',
    },
    cartChapterTitle: {
      type: String,
      default: '',
    },
    diffText: {
      type: Array,
      default() {
        return [];
      },
    },
    diffName: {
      type: Array,
      default() {
        return [];
      },
    },
    color: {
      type: String,
      default: 'blue',
    },
  },
};
</script>
